// State management
import { useAppSelector } from "../../../../services/StoreHelper";

// Styles
import body_top_styles from "./body_top_styles";

function BodyTop() {
  const { user, club } = useAppSelector((state) => state.app);

  // 🔹 Toggle language here (can be lifted later)
  const { usesSpanish } = club;

  // 🔹 Inline translations
  const TEXT = {
    headline: usesSpanish ? "Administrar mis acuerdos" : "Manage My Agreements",
  };

  return (
    <div style={body_top_styles.body_top}>
      {user?.UserID && (
        <div style={body_top_styles.username}>
          {user.FirstName} {user.LastName}
        </div>
      )}

      <div style={body_top_styles.headline}>{TEXT.headline}</div>
    </div>
  );
}

export default BodyTop;